import { CheckCircle, HighlightOff } from '@mui/icons-material';
import { Box, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { Dialog } from '@mui/material';
import { Button } from '../../../../components/shared';
import TimerModal from '../../../../components/TimerModal/TimerModal';
import { MESSAGE } from '../../../../constants/message';

const MonthlyFinalizeDialogs = ({
  appliedFilters,
  finalizeError,
  finalizedData,
  isFinalizingReconciliation,
  onCloseConfirm,
  onConfirmFinalize,
  onFailureClose,
  onSuccessClose,
  postingDate,
  showConfirmModal,
  showFailureModal,
  showSuccessModal,
}) => (
  <>
    <Dialog
      open={showConfirmModal}
      onClose={() => !isFinalizingReconciliation && onCloseConfirm()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle variant="subtitle10">Confirm Finalization</DialogTitle>
      <DialogContent>
        <DialogContentText variant="body1" sx={{ mb: 2 }}>
          You are about to finalize the reconciliation window:
        </DialogContentText>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography variant="body2">
            <strong>Start Date:</strong> {appliedFilters?.startDate}
          </Typography>
          <Typography variant="body2">
            <strong>End Date:</strong> {appliedFilters?.endDate}
          </Typography>
          <Typography variant="body2">
            <strong>X3 Product:</strong> {appliedFilters?.x3_productname || 'N/A'}
          </Typography>
          <Typography variant="body2">
            <strong>Posting Date:</strong> {postingDate || 'N/A'}
          </Typography>
        </Box>
        <DialogContentText variant="body1" sx={{ mb: 1 }}>
          This will:
        </DialogContentText>
        <Box sx={{ pl: 2 }}>
          <Typography variant="body2">• Create a final Catch-Up Posting ID for remaining variance</Typography>
          <Typography variant="body2">• Permanently lock this date range</Typography>
          <Typography variant="body2">• Prevent any future Weekly GL postings that overlap this window</Typography>
        </Box>
        <DialogContentText variant="body1" sx={{ mt: 2, fontWeight: 'bold' }}>
          This action cannot be undone. Do you want to continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCloseConfirm} variant="outlined" color="secondary" disabled={isFinalizingReconciliation}>
          Cancel
        </Button>
        <Button onClick={onConfirmFinalize} variant="contained" color="primary" disabled={isFinalizingReconciliation}>
          {isFinalizingReconciliation ? 'Finalizing...' : 'Confirm Finalize'}
        </Button>
      </DialogActions>
    </Dialog>

    <TimerModal
      isOpen={showSuccessModal}
      timer={3}
      activate={showSuccessModal}
      onTimeComplete={onSuccessClose}
      onClose={onSuccessClose}
      allowBackdropClick
      closeIcon
      icon={<CheckCircle color="success" sx={{ fontSize: '4rem' }} />}
      title={MESSAGE.SUCCESSFUL}
      msg={`Reconciliation finalized\nsuccessfully\nPosting ID: ${finalizedData?.postingId || 'N/A'}`}
    />

    <TimerModal
      isOpen={showFailureModal}
      timer={5}
      activate={showFailureModal}
      onTimeComplete={onFailureClose}
      onClose={onFailureClose}
      allowBackdropClick
      closeIcon
      icon={<HighlightOff color="error" sx={{ fontSize: '4rem' }} />}
      title={MESSAGE.FAILED}
      msg={`Failed to finalize monthly reconciliation. ${
        finalizeError || 'Please try again.'
      } This message will be closed in`}
    />
  </>
);

export default MonthlyFinalizeDialogs;
